import { apiFetchJson } from "./apiClient";

export interface Campaign {
  id: number;
  name: string;
  setting: string;
  type: string;
  description?: string;
  world?: string;
  isPublic?: boolean;
  maxPlayers?: number;
  users?: {
    id: number;
    username: string;
    name: string;
    email: string;
  }[];
}

export interface CampaignListItem {
  id: number;
  name: string;
  setting: string;
  type: string;
  description?: string;
  world?: string;
  isPublic?: boolean;
  maxPlayers?: number;
}

export interface CampaignListRequest {
  name?: string;
  type?: string;
  world?: string;
  page: number;
  pageSize: number;
}

export interface CampaignListResponse {
  total: number;
  page: number;
  pageSize: number;
  campaigns: CampaignListItem[];
}

export class CampaignService {
  /**
   * Get list of campaigns with filtering and pagination
   */
  static async getCampaigns(request: CampaignListRequest): Promise<CampaignListResponse> {
    return apiFetchJson<CampaignListResponse>("/api/protected/campaigns", {
      method: "POST",
      body: JSON.stringify(request),
    });
  }

  /**
   * Get campaigns available to the current user (owned or invited)
   */
  static async getAvailableCampaigns(): Promise<CampaignListItem[]> {
    try {
      const data = await apiFetchJson<CampaignListItem[]>("/api/protected/campaigns/available");
      return data ?? [];
    } catch {
      // Fallback: get all campaigns
      try {
        const all = await CampaignService.getCampaigns({ page: 0, pageSize: 100 });
        return all.campaigns;
      } catch {
        return [];
      }
    }
  }

  /**
   * Get a specific campaign by ID
   */
  static async getCampaign(id: number): Promise<Campaign> {
    return apiFetchJson<Campaign>(`/api/protected/campaigns/campaign/${id}`);
  }
}
